module.exports = __webpack_public_path__ + "static/media/fiber.025cd4ce.gif";